// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4288b8ad","537":"f8fa007a"}[chunkId] + ".chunk.js";
};